import { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import {
  getAllProgress,
  getTotalProgressCount,
} from "../../services/ProgressService";

const ProgressChart = () => {
  const [progressData, setProgressData] = useState({
    "Good progress": 0,
    "Moderate progress": 0,
    "Poor progress": 0,
  });
  const [totalProgressCount, setTotalProgressCount] = useState(0);

  const fetchProgressData = async () => {
    try {
      const countResponse = await getTotalProgressCount();
      const count = countResponse.data?.data || 0;
      setTotalProgressCount(count);

      const progressListResponse = await getAllProgress();
      const progressList = Array.isArray(progressListResponse.data?.data)
        ? progressListResponse.data?.data
        : [];

      if (progressList.length === 0) {
        setTotalProgressCount(0);
        return;
      }

      let goodProgress = 0;
      let moderateProgress = 0;
      let poorProgress = 0;

      progressList.forEach((progress) => {
        try {
          const study = progress.studyId;

          if (!study || !study.finish_date) {
            poorProgress++;
            return;
          }

          const studyFinishDate = new Date(study.finish_date);

          const meetProgressPlanYes =
            progress.meet_progress_plan &&
            progress.meet_progress_plan.toUpperCase() === "YES";

          const submitThesisBeforeFinishDate =
            progress.submit_thesis &&
            new Date(progress.submit_thesis) < studyFinishDate;

          const studyCompletionBeforeFinishDate =
            progress.study_complition &&
            new Date(progress.study_complition) <= studyFinishDate;

          let criteriaMetCount = 0;
          if (meetProgressPlanYes) criteriaMetCount++;
          if (submitThesisBeforeFinishDate) criteriaMetCount++;
          if (studyCompletionBeforeFinishDate) criteriaMetCount++;

          if (criteriaMetCount === 3) {
            goodProgress++;
          } else if (criteriaMetCount === 2) {
            moderateProgress++;
          } else {
            poorProgress++;
          }
        } catch (err) {
          poorProgress++;
        }
      });

      setProgressData({
        "Good progress": goodProgress,
        "Moderate progress": moderateProgress,
        "Poor progress": poorProgress,
      });
    } catch (error) {
      console.error("Error fetching progress data:", error);
    }
  };

  useEffect(() => {
    fetchProgressData();
  }, []);

  const percentages = {
    "Poor progress":
      totalProgressCount > 0
        ? (progressData["Poor progress"] / totalProgressCount) * 100
        : 0,
    "Moderate progress":
      totalProgressCount > 0
        ? (progressData["Moderate progress"] / totalProgressCount) * 100
        : 0,
    "Good progress":
      totalProgressCount > 0
        ? (progressData["Good progress"] / totalProgressCount) * 100
        : 0,
  };

  const labels = ["Poor progress", "Moderate progress", "Good progress"];
  const seriesData = [
    percentages["Poor progress"],
    percentages["Moderate progress"],
    percentages["Good progress"],
  ];
  const chartColors = ["#F94144", "#F3A23A", "#4CAF50"];

  const options = {
    chart: {
      type: "pie",
    },
    series: seriesData,
    labels: labels,
    colors: chartColors,
    plotOptions: {
      pie: {
        labels: {
          show: true,
          name: {
            show: true,
            fontSize: "16px",
            color: "#888",
            offsetY: 20,
          },
          value: {
            show: false,
          },
        },
      },
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        if (val < 1) return "";
        return val.toFixed(0) + "%";
      },
      style: {
        fontSize: "12px",
        fontWeight: "bold",
        colors: ["#fff"],
      },
      dropShadow: {
        enabled: true,
        opacity: 0.5,
      },
    },
    legend: {
      show: true,
      position: "bottom",
      horizontalAlign: "left",
      markers: {
        width: 12,
        height: 12,
        fillColors: chartColors,
      },
    },
    tooltip: {
      enabled: true,
      y: {
        formatter: function (val) {
          return val.toFixed(1) + "%";
        },
      },
    },
    stroke: {
      show: false,
    },
  };

  return (
    <div>
      <Chart
        options={options}
        series={options.series}
        type="pie"
        width="100%"
      />
    </div>
  );
};

export default ProgressChart;
